import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createRule } from 'api/wage/createRule'
import { wageRuleKeys } from './keys'

export const useCreateRuleMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof createRule>[0]) =>
      createRule(request),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: wageRuleKeys.all })
    },
  })
}
